import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService, CoreProxyService, CoreTypes, SharedCommonService } from 'common-cloudstudio';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-shared-dashboard',
  templateUrl: './shared-dashboard.component.html',
  styleUrls: ['./shared-dashboard.component.scss']
})
export class SharedDashboardComponent implements OnInit, OnDestroy {

  genericToken: string = null;
  facilityId: number = null;
  dashboardId: number = null;
  accessToken: string = null;
  formParameters: CoreTypes.FormParameter[] = [];
  subscriptions: Subscription[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    public _coreProxyService: CoreProxyService,
    private _sharedCommonService: SharedCommonService,
    private _appService: AppService
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(this.activatedRoute.params.subscribe(params => {
      this.genericToken = params.genericToken;
      this.getData();
    }));
  }

  ngOnDestroy() {
    this._sharedCommonService.onTokenForViews.next(null);
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getData() {
    this._coreProxyService.DashboardService.GetSharedDashboardData(
      this.genericToken,
      res => {
        this.accessToken = res.AccessToken;
        this.facilityId = res.FacilityID;
        this.dashboardId = res.DashboardID;
        this.formParameters = res.Parameters;
        this._appService.regionalFormats.next(res.RegionalFormats);
        this._sharedCommonService.onTokenForViews.next(this.accessToken);
        const expirationTime = ((res.AccessTokenExpirationSeconds*75)/10)*100;
        setTimeout(() => this.getData(), expirationTime);
      },
      err => {
        setTimeout(() => this.getData(), 15000);
        this._appService.showException(err);
      }
    );
  }

}
